import React from 'react';
import { fromStorage } from '../../../../utils';
import { DownloadIcon } from '../../../../assets/icons';

const ModalEvidence = ({ item, onClose }) => {
  const evidenceUrl = item?.evidence ? fromStorage(item.evidence) : null;

  const downloadFile = (url) => {
    if (url) {
      const link = document.createElement('a');
      link.href = url;
      link.target = '_blank';
      link.download = url.split('/').pop();
      document.body.appendChild(link);
      link.click();
      link.remove();
    }
  };

  return (
    <div className="mx-auto bg-white rounded-2xl shadow-lg overflow-y-auto w-[42rem] max-h-[90vh]">
      <div className="flex justify-between items-center p-4 pb-2">
        <h2 className="text-xl font-bold text-text">Evidencia de Falla</h2>
        <button onClick={onClose} className="text-default hover:text-text transition-colors">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>

      <div className="p-4 pt-2 space-y-4">
        <div className="bg-gray5 rounded-xl flex items-center justify-center min-h-[16rem] max-h-[70vh] overflow-hidden">
          {evidenceUrl ? (
            <img
              src={evidenceUrl}
              alt="Evidencia"
              className="max-w-full max-h-[50vh] object-contain rounded-xl"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = '';
                if (e.target.parentElement?.innerHTML) {
                  e.target.parentElement.innerHTML = '<p class="text-default p-8">No se pudo cargar la imagen</p>';
                }
              }}
            />
          ) : (
            <p className="text-default p-8">Sin evidencia adjunta</p>
          )}
        </div>

        {item?.vehicle?.plaque && (
          <div className="grid grid-cols-2 gap-4 text-sm">
            <div>
              <p className="text-default">Vehículo</p>
              <p className="text-text font-medium">{item.vehicle.plaque}</p>
            </div>
            <div>
              <p className="text-default">Conductor</p>
              <p className="text-text font-medium">{item?.driver?.person?.fullName || '-'}</p>
            </div>
          </div>
        )}

        <div className="flex justify-end">
          <button
            className="flex items-center gap-2 bg-black text-white px-4 py-1.5 rounded-lg font-semibold text-sm"
            onClick={() => downloadFile(evidenceUrl)}
          >
            <img src={DownloadIcon} className="w-4 h-4 brightness-200" alt="" />
            Descargar
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalEvidence;
